var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoSquar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons_info.square.fill",
    "data-name": "Icons=info.square.fill",
    transform: "translate(-3 -3.023)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M6.163,21.023H17.837c2.089,0,3.163-1.074,3.163-3.132V6.155c0-2.059-1.074-3.132-3.163-3.132H6.163C4.082,3.023,3,4.088,3,6.155V17.892C3,19.957,4.082,21.023,6.163,21.023Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M11.645,18.191a.776.776,0,0,1-.808-.79.787.787,0,0,1,.808-.777h1.188V12.453H11.819a.776.776,0,0,1-.8-.788.788.788,0,0,1,.8-.779h1.906c.572,0,.871.4.871,1.007v4.731h1.11a.789.789,0,0,1,.809.777.778.778,0,0,1-.809.79Zm1.708-8.851a1.385,1.385,0,1,1,1.365-1.383A1.378,1.378,0,0,1,13.353,9.341Z",
    transform: "translate(-1.388 -0.628)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoSquar);
export default __webpack_public_path__ + "static/media/info-squar.f39ab66e9739da4caba6957cec5b9ee1.svg";
export { ForwardRef as ReactComponent };